import { InventoryList, UserInventoryList } from '../inventory'
import { FirestoreDataConverter, DocumentSnapshot, SnapshotOptions, WithFieldValue } from 'firebase/firestore'

export const inventoryListConverter: FirestoreDataConverter<InventoryList> = {
  toFirestore(inventoryList: WithFieldValue<InventoryList>) {
    const { id, ...data } = inventoryList
    return data
  },
  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): InventoryList {
    const data = snapshot.data(options)
    const rawDate = data?.dateCreated
    let dateCreated: string | null = null
    if (typeof rawDate === 'string') {
      dateCreated = rawDate
    } else if (rawDate?.toDate instanceof Function) {
      dateCreated = rawDate.toDate().toISOString()
    } else if (rawDate instanceof Date) {
      dateCreated = rawDate.toISOString()
    }

    return {
      id: snapshot.id,
      dateCreated,
      createdBy: data?.createdBy || '',
      inventoryIds: data?.inventoryIds || [],
      name: data?.name || '',
      description: data?.description || '',
      isArchived: data?.isArchived || false,
    }
  },
}

export const userInventoryListConverter: FirestoreDataConverter<UserInventoryList> = {
  toFirestore(userList: WithFieldValue<UserInventoryList>) {
    const { id, ...data } = userList
    return data
  },
  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): UserInventoryList {
    const data = snapshot.data(options)
    return {
      id: snapshot.id,
      userId: data?.userId || '',
      inventoryListId: data?.inventoryListId || '',
      dateAdded: data?.dateAdded || new Date().toISOString(),
    }
  },
} 